module.exports = __webpack_public_path__ + "img/ally-ar.cc08af03.png";